import { Component, OnInit, ViewChild } from '@angular/core';
import { PageAction } from '../../components/page-actions/page-actions.component';
import { Router } from '@angular/router';
import { GroupService } from '@services/groups/group.service';
import { DataTableComponent, DataTableEvent } from '../../components/data-table/data-table.component';
import { DialogService } from '@services/dialog/dialog.service';
import { SnackbarService } from '@services/snackbar/snackbar.service';

@Component({
    selector: 'app-groups',
    templateUrl: './groups.component.html',
    styleUrls: ['./groups.component.scss'],
    providers: [GroupService],
    standalone: false
})
export class GroupsComponent implements OnInit {

  @ViewChild(DataTableComponent) dataTable: DataTableComponent;
  public title = 'Groups';

  public pageActions: PageAction[];

  public columns = [
    { prop: 'name' }
  ];
  dataProviderParams = { isPersonal: 0 };

  constructor(
    public groupService: GroupService,
    private router: Router,
    private dialogService: DialogService,
    private snackbar: SnackbarService
  ) {
  }

  ngOnInit() {
    this.pageActions = [
      new PageAction({
        icon: 'add',
        title: 'Create Group',
        callback: () => {
          this.router.navigate(['groups/create']);
        }
      })
    ];
  }

  public onEdit(event: DataTableEvent) {
    this.router.navigate(['groups', event.row.GroupID, 'edit']);
  }

  public onDetail(event: DataTableEvent) {
    this.router.navigate(['groups', event.row.GroupID]);
  }

  public async onRemove(event: DataTableEvent): Promise<any> {
    const res = await this.dialogService.confirm('Delete this group and group-has-profiles ?')
    if (!res) {
      return;
    }
    try {
      await this.groupService.remove(event.row.GroupID);
      this.dataTable.refresh();
      this.snackbar.success('Group removed');
    } catch (error) {
      const message = (error.error.message ? error.error.message : error.message);
      console.error(error);
      return this.dialogService.confirm(message, error.name);
    }
  }

}
